import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

export const TooltipHeader = styled.div`
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const TooltipRowTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  color: ${colors.grey5};
`;

export const TooltipRowValue = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 19px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const TooltipRow = styled.div`
  display: grid;
  grid-template-columns: minmax(100px, 100px) 1fr;
  padding: 2px;
  width: 100%;
`;

export const TooltipItem = styled.div`
  display: flex;
  align-items: center;

  ${TooltipRowTitle} {
    margin-right: 10px;
  }
`;
